import { dateFormat } from 'common/helpers/dateHelper';

const Fulfillments = (props) => {
  const { fulfillmentItem, settings } = props;
  switch (fulfillmentItem.type) {
    case 'No Fulfillment Required': {
      return (
        <>
          On {dateFormat(fulfillmentItem.fulfillmentDate, settings)} order
          marked no fulfillment required.
        </>
      );
    }
    case 'Picked Up': {
      return (
        <>
          <span>
            <strong>
              Picked up on{' '}
              {dateFormat(fulfillmentItem.fulfillmentDate, settings)}
            </strong>
            <br />
            {fulfillmentItem.pickedUp.pickedUpBy} picked up{' '}
            <strong>{fulfillmentItem.packageCount}</strong>{' '}
            {fulfillmentItem.packageCount === 1 ? 'package' : 'packages'}
          </span>
        </>
      );
    }
    case 'Shipped': {
      return (
        <>
          <span>
            <strong>
              Shipped on {dateFormat(fulfillmentItem.fulfillmentDate, settings)}
            </strong>
            <br />
            {fulfillmentItem.shipped.carrier} is delivering{' '}
            <strong>{fulfillmentItem.packageCount}</strong>{' '}
            {fulfillmentItem.packageCount === 1 ? 'package' : 'packages'}
          </span>
          <span>
            <strong>Shipment Tracking</strong>
            <br />
            {fulfillmentItem.shipped.trackingNumbers.map((track) => (
              <span key={track}>{track}</span>
            ))}
          </span>
        </>
      );
    }
    default:
      throw new Error('Invalid fulfillment type');
  }
};

export default Fulfillments;
